module.exports = __webpack_public_path__ + "static/media/value-proposition-salary@2x.6f82735e.png";